var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('b-skeleton-img',{attrs:{"height":"100px"}}):_c('summary-message-sales-report',{attrs:{"title":_vm.widget.name,"currency":"","amount":_vm.amount.toString()}})}
var staticRenderFns = []

export { render, staticRenderFns }